import { omniAtom } from "src/utils/atoms";

export interface StorePogNotesModalData {
  storePogId: number;
  canEdit: boolean;
}

export const storePogNotesModalAtom = omniAtom<StorePogNotesModalData | null>({
  key: "modals/storePogNotes",
  value: null,
});
